import { animate, state, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { COMMA, ENTER, SEMICOLON } from '@angular/cdk/keycodes';
import { OverlayConfig } from '@angular/cdk/overlay';

import { Component, Inject, OnChanges, OnInit, QueryList, SimpleChanges, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormArray, FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatRipple } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { BehaviorSubject, Observable, Subject, Subscription, take, takeUntil } from 'rxjs';
import { FormulaServices } from 'src/app/services/formula.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Variable } from '../../formula-tester/formula-tester.component';
import { FormServices } from 'src/app/services/form.services';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThemeService } from 'src/app/services/theme.service';


export interface Request{
  request:RequestConfiguration[];
}
export interface RequestConfiguration{
  tagName?:string;
  name:string;
  url?:string;
  serviceName?:string;
  typeUrl?:string;
  headerProperties?:string;
  typeTech?:number;
  requestMethod?:string;
  chieldPath?:string;
  variables?:RequestConfigurationVariables[];
  chield?:RequestConfiguration[];
  requestBody?:string;
  finally?:boolean;
  conditionalExecution?:string;
  useBodyCreator?:boolean;
  gravarStatus?:boolean;
  tabelaStatus?:string;
  sleepFormula?:string;
  saveResponseFields?:string;
  isFile?:boolean;
  throwError?:boolean;
  successStatus?:string;
  errorStatus?:string;
  successMessage?:string;
  path?:string;
  charSet?:string;
  conditionalAfterExecution?:ConditionalExecution[];
  
}

export interface ConditionalExecution{
  conditional:string;
  message:string;

}

export interface RequestConfigurationVariables{
  type:string;
  name:string;
  formula:string;
}

@Component({
    selector: 'app-request-type-service',
    templateUrl: './request-type-service.component.html',
    styleUrls: ['./request-type-service.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateY({{offset}}%)' }),
                animate('1000ms ease-in', style({ transform: 'translateY(0%)' }))
            ]),
        ]),
        trigger('tabMovement', [
            state('up', style({ transform: 'translateY(0%)' })),
            state('down', style({ transform: 'translateY(0%)' })),
            transition('*<=>*', [style({ transform: 'translateY({{offset}}%)' }), animate('0.5s')])
        ])
    ],
    standalone: false
})

export class RequestTypeServiceComponent implements OnInit {

  @ViewChildren(MatRipple) public matRipples!:QueryList<MatRipple>;
  showCID: boolean=true;
  usePayloadCreator: any;
  showOthers: boolean;
  showConn: boolean;
  showSankhyaInstance: boolean = false;
  showSankhyaFile: boolean = false;
  showPagination: boolean = true;
  showEnableServices:boolean =true;

  constructor(
      private fb:UntypedFormBuilder, 
      private http:HTTPService,
      private formulaService:FormulaServices,
      @Inject(MAT_DIALOG_DATA) public dialogData,
      public dialogRef: MatDialogRef<any>,
      private snackBar:SnackbarService,
      private formServices:FormServices,
      public ThemeService:ThemeService,
      private spinner:NgxSpinnerService) { }

  integrationData;
  active:boolean =true;
  new:boolean = false;
  editing:boolean = true;
  configuration:Request;
  selected = 1;
  selectedName  = 'info';
  typeSelection='down';
  multiplyer = 0;
  multiplyerBody = 100;
  canSeeProtectTypeService = false;
  step1:UntypedFormGroup;
  step2:UntypedFormGroup;
  step3:UntypedFormGroup;
  stepHeader:UntypedFormGroup;
  stepParameter:UntypedFormGroup;
  stepDataSave:UntypedFormGroup;
  expressionForm:UntypedFormGroup;
  addOnBlur = true;
  enableServices = false;
  typeUrlList = new   BehaviorSubject<Object[]>([]);
  typeServiceList = new BehaviorSubject<Object[]>([]);
  typeServiceFiltered = new BehaviorSubject<Object[]>([]);
  showConsultaDados = false;
  showRequestMethod = false;
  showSaveResponse = false;
  saveResponse = false;
  showTypeTech = false;
  showRetry = true;
  joinSql = false;
  retry = false;
  showTableName = false;
  headerSugestList:{key:string,value:string}[] = [];
  paramSugestList:{key:string,value:string}[] = [];
  showAlteracaoDados = false;
  hasOffSet = false;
  formulaOffSet = false;
  offSetBody = false;
  showQuota = false;
  //showQuotaFields = false;
  showHeader = true;
  showParams = true;
  formulaThrottling ='';
  codeThrottling = '';
  stepData:Object[] = [];
  ob1:Subscription;
  ob2:Subscription;
  ob3:Subscription;
  showDataTransform:boolean = false;
  typeServicesCodesFiltered:Object[] = [];
  protected _onDestroy = new Subject<void>();
  conditionSearch = ` EXISTS (SELECT 1 FROM Mktpdiccol c where  c.idinstance  = entityPrincipal.idinstance and c.columnname = 'CODECOMPANY')`;
  showSankhyaQuerys =false;

  readonly requestMethodCodes = [
      {
        requestMethod: 'GET'
      },
      {
        requestMethod: 'GETOK',
        description: 'Método utilizando ferramenta OKHttp. Saiba mais: https://square.github.io/okhttp/'
      },
      {
        requestMethod: 'POST',
      },
      {
        requestMethod: 'POSTOK',
        description: 'Método utilizando ferramenta OKHttp. Saiba mais: https://square.github.io/okhttp/'
      },
      {
        requestMethod: 'PUT',
      },
      {
        requestMethod: 'PUTOK',
        description: 'Método utilizando ferramenta OKHttp. Saiba mais: https://square.github.io/okhttp/'
      },
      {
        requestMethod: 'DELETE',
      },
      {
        requestMethod: 'DELETEOK',
        description: 'Método utilizando ferramenta OKHttp. Saiba mais: https://square.github.io/okhttp/'
      },
      {
        requestMethod: 'PATCH',
      },
      {
        requestMethod: 'PATCHOK',
        description: 'Método utilizando ferramenta OKHttp. Saiba mais: https://square.github.io/okhttp/'
      },
      {
        requestMethod: 'POSTFILE',
        description: 'Método para postar arquivos.'
      },
      {
        requestMethod: 'POSTOKFILE',
        description: 'Método para postar arquivos utilizando a Ferramenta OKHttp.'
      },
      {
        requestMethod: 'PUTFILE',
        description: 'Método para atualizar arquivos.'
      },


 ]


 readonly typeServicesCodes = 
    [
      {
        serviceType:1,
        name:"Executa Query e Envia Para Serviço",
        description:"Serviço para buscar dados em tabelas e enviar para um serviço http. Para cada linha do resultado da query é feito uma requisição na URL informada.",
        protect: true,
        type:3
      },
      {
        serviceType:2,
        name:"Executa uma Requisição",
        description:"Serviço para executar requisições. O serviço é executado de forma assíncrona nas sincronizações.",
        protect: true,
        type:2
      },
      {
        serviceType:4,
        name:"Busca retorno de Seviços e Insere em Instância da TemAPI",
        description:"Serviço utilizado geralmente com Tipo 2. Tem com objetivo, buscar o response da etapa anterior e enviar inserir no banco de dados.",
        protect: true,
        type:3
      },
      {
        serviceType:5,
        name:"Busca dados de uma instância da TemAPI e envia para o Sankhya",
        description:"Serviço para inserção de dados no modelo do ERP Sankhya",
        protect: true,
        type:3
      },
      {
        serviceType:7,
        name:"Executa uma Consulta SQL e Insere numa Instância da TemAPI",
        description:"Serviço para inserção de dados no modelo do ERP Sankhya",
        protect: true,
        type:3
      },
      {
        serviceType:11,
        name:"Busca dados de uma query e envia para anexos do Sankhya (TISATA)",
        description:"Serviço para inserção de dados no modelo do ERP Sankhya",
        protect: true,
        type:3
      },
      {
        serviceType:12,
        name:"Busca dados de uma query e envia para XML do Sankhya (TISATA)",
        description:"Serviço para inserção de dados no modelo do ERP Sankhya",
        protect: true,
        type:3
      },
      {
        serviceType:15,
        name:"Serviço de Requisições de WebServices",
        description:"Serviço utilizado para encadear requisições em servidores",
        protect: false,
        type:3
      },
      {
        serviceType:16,
        name:"Serviço de acesso a banco de dados remoto",
        description:"Serviço utilizado acessar banco de dados diretamente",
        protect: false,
        type:3
      },
      {
        serviceType:19,
        name:"Serviço de acesso a banco de dados local da TemAPI",
        description:"Serviço utilizado acessar banco de dados diretamente",
        protect: true,
        type:3
      }
  ] as const;

  typeFile = [
      'CSV',
      'JPEG',
			'JPG',
      'GIF',
      'PNG',
			'XML'
  ] as const;

  readonly step = [
      {
        name: 'info',
        desc: 'Informações'
      },
      {
        name: 'misc',
        desc: 'Outros Dados'
      },
      {
        name: 'conn',
        desc: 'Dados de Conexão'
      },
      {
        name: 'header',
        desc: 'Header/Cabeçalho'
      },
      {
        name: 'query',
        desc: 'Consulta de Dados'
      },
      {
        name: 'param',
        desc: 'Parâmetros de Formulário'
      },
      {
        name: 'dpara',
        desc: 'D-Para de Dados'
      },
      {
        name: 'datasave',
        desc: 'Configurações de Alteração de Dados'
      },
      {
        name: 'datatransform',
        desc: 'Transformação de Dados'
      },
      {
        name: 'snkfile',
        desc: 'Envio de Arquivos para o Sankhya'
      },
      {
        name: 'snkinst',
        desc: 'Envio de Instâncias para o Sankhya'
      },
      {
        name: 'snkquery',
        desc: 'Execução de Querys para o Sankhya'
      }
      
  ] as const;

  readonly typeTechCodes = [
    {
      typeTech:1,
      name:'JSON'
    },
    {
      typeTech:2,
      name:'XML'
    },
    {
      typeTech:4,
      name:'LoadView'
    },
    {
      typeTech:5,
      name:'DbExplorer'
    },
    {
      typeTech:6,
      name:'HTML'
    },
    {
      typeTech:7,
      name:'ZIP'
    },
    {
      typeTech:8,
      name:'CSV'
    },
    {
      typeTech:9,
      name:'XLS'
    },
    {
      typeTech:10,
      name:'Delimitado'
    }

  ] as const;

  
    	  
  readonly separatorKeysCodes = [SEMICOLON,ENTER] as const;

  
  ngOnInit(): void {

    this.spinner.show('requestform');
    this.integrationData = this.dialogData;
    this.stepData = JSON.parse(JSON.stringify(this.step));
    //this.integrationData =  {idConf: 4201, sequence: 2, codeCompany: 155, codeContract: 0, codeMktp: 3,
      //typeIntegration:{nuInt:11}};

    this.typeServicesCodesFiltered.push(...this.typeServicesCodes);
    
    
    this.step1 = this.fb.group({
      NAME: new UntypedFormControl(null,[Validators.required]),
      MAINTAGNAME: new UntypedFormControl(null,[Validators.required]),
      OBJECTTAG: new UntypedFormControl(null,[Validators.required]),
      TYPETECH: new UntypedFormControl(null),
      SERVICETYPE:new UntypedFormControl(this.integrationData.typeIntegration.nuInt,[Validators.required]),
      SAVERESPONSE: new UntypedFormControl("N"),
      RETRY: new UntypedFormControl("N"),
      ACTIVE: new UntypedFormControl("N"),
      EXECUTION: new UntypedFormControl("1"),
      EXECORDER: new UntypedFormControl(this.integrationData.sequence),
      TYPE: new UntypedFormControl(),
    });

    this.step2 = this.fb.group({
      URL: new UntypedFormControl(null),
      SERVICENAME: new UntypedFormControl(null),
      TYPEURL: new UntypedFormControl(null), 
      REQUESTMETHOD: new UntypedFormControl(null),
      TIMEOUT: new UntypedFormControl(null),
      CHARSET: new UntypedFormControl(null),
      CERTIFICATEPARAMS: new UntypedFormControl(null),
      CRYPTOCONFIG: new UntypedFormControl(null),
      CUSTOMARRAY: new UntypedFormControl(null), // implementar função, realizar iteração dentro de um objeto(xml,json) dentro de um campo da tabela;
      HASOFFSET: new UntypedFormControl(false),
      OFFSETEXPRESSION: new UntypedFormControl(null),
      OFFSETINTERVAL: new UntypedFormControl(null),
      OFFSETSTART: new UntypedFormControl(null),
      OFFSETBODY: new UntypedFormControl(null),
      FORMULAOFFSET: new UntypedFormControl(null),
      QUOTAREQUEST: new UntypedFormControl(null),
      QUOTAINTERVAL: new UntypedFormControl(null),
      QUOTAREQUESTSIZE: new UntypedFormControl(null),
      LASTREQUEST: new UntypedFormControl(null),
      SLEEPFORMULA: new UntypedFormControl(null),
      LOGOUT: new UntypedFormControl("N")

    });

    this.step3 = this.fb.group({
      EXECUTEBEFORE:new UntypedFormControl(null),
      EXECUTEAFTER:new UntypedFormControl(null),
      MAINTAGNAME:new UntypedFormControl(null),
      VALIDATEBEFORESEND:new UntypedFormControl(null),
      CONDITIONALEXECUTION:new UntypedFormControl(null),
      REQUESTBODY:new UntypedFormControl(null)
      
    })

    this.step2.get('QUOTAREQUESTSIZE').disable();
    this.step2.get('LASTREQUEST').disable();

    this.stepHeader = this.fb.group({
      HEADERPROPERTIES: this.fb.array([]),
    });

    this.headerSugestList = [
      { key:'Content-Type', value:'application/json'},
      { key:'Content-Type', value:'application/xml'},
      { key:'Accept', value:'*/*'},
      { key:'Connection', value:'keep-alive'},
      { key:'User-Agent', value:'TemAPI'},
      { key:'Authorization', value:'Bearer {@MKTPACTIVECOMPANIES.ACESSTOKEN}'},
      { key:'Authorization',value:'basicAuthentication({@MKTPACTIVECOMPANIES.APIUSERNAME},{@MKTPACTIVECOMPANIES.APIPASSWORD})'},
      { key:'Authentication', value:'Bearer {@MKTPACTIVECOMPANIES.ACESSTOKEN}'},
      { key:'Authentication',value:'basicAuthentication({@MKTPACTIVECOMPANIES.APIUSERNAME},{@MKTPACTIVECOMPANIES.APIPASSWORD})'}
    ]

    this.stepParameter = this.fb.group({
      PARAMPROPERTIES: this.fb.array([]),
    });

    this.expressionForm = this.fb.group({
      JOINSQL: new UntypedFormControl("N"),
      EXPRESSION: new UntypedFormControl(null),
      PACKSIZE: new UntypedFormControl(null)
    });

    this.stepDataSave = this.fb.group({
      TABLENAME: new UntypedFormControl(null),
      SAVERESPONSEFIELDS: new UntypedFormControl(null),
      ERRORSTATUS: new UntypedFormControl("2",[Validators.required]),
      SUCCESSSTATUS: new UntypedFormControl("1",[Validators.required]),
    })

    this.loadIntegrationInfo().then(data=>{
      
      this.formServices.refreshFormObject(this.step1,data,false);
      this.formServices.refreshFormObject(this.step2,data,false);
      this.formServices.refreshFormObject(this.step3,data,false);
      this.formServices.refreshFormObject(this.expressionForm,data,false);
      this.formServices.refreshFormObject(this.stepDataSave,data,false);
      
      this.transformObjectArray(data["HEADERPROPERTIES"],(this.stepHeader.get("HEADERPROPERTIES") as FormArray));
      this.transformObjectArray(data["PARAMPROPERTIES"],(this.stepHeader.get("PARAMPROPERTIES") as FormArray));
      
      
      this.doFace(this.integrationData.typeIntegration.nuInt);
      this.spinner.hide('requestform');
      this.onChangeServices(this.enableServices);
      if ( this.enableServices ){
        this.loadServices();
      }
    })
  }


  loadIntegrationInfo(){

    return new Promise((resolve,reject)=>{
      let ob = {
        entityName: 'Mktpcfi',
        rows: 1,
        showPresentation: true,
        showRelationshipData: false,
        showRelationship: true,
        fetchSize: 0,
        condition: ` IDCONF = ${this.integrationData.idConf} AND SEQUENCE=${this.integrationData.sequence}`,
      };
  
      this.http.post(ob, "JsonBrokerServices/find", true).subscribe(
        (x) => {
            resolve(x['Mktpcfi'][0]); 
        });
    });
    
    
  }

  drop(event: CdkDragDrop<RequestConfiguration[]>) {
    moveItemInArray(this.configuration.request, event.previousIndex, event.currentIndex);
  }

  editItem(event, showRipple, index = 0, novo:boolean){
      if ( showRipple ){
        this.matRipples.get(index)!.launch({ centered: true });
      }

      this.editing = true;
      if ( novo ){
        this.new = true;
      }
  }

  onChangeServices(event){

    if ( event ){

      this.step2.get('TYPEURL').addValidators(Validators.required);
      this.step2.get('SERVICENAME').addValidators(Validators.required);

      let ob = {
        "entityName":"Mktpcontractpref",
        "sql":`SELECT  TYPEURL, URL
              FROM MKTPURLS
              WHERE (CODEMKTP = ${this.integrationData.codeMktp} AND ENVIRONMENT=1 ) `
      }
       
      this.ob1 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
        next:  (data)=>{
          if ( data['SQL']){
            this.typeUrlList.next(data['SQL']);
          }
        },
        error: (error)=>{
          throw error;
        }});
    }else{
      this.typeUrlList.next([]);
      this.typeServiceList.next([]);
      //this.step2.get('TYPEURL').setValue(null);
      //this.step2.get('SERVICENAME').setValue(null);
      this.step2.get('TYPEURL').removeValidators(Validators.required);
      this.step2.get('SERVICENAME').removeValidators(Validators.required);
    }
  }

  fillNativeFormula(){
      if ( this.enableServices ){
        this.step2.get('URL').setValue("CONCATENAR({@MKTPURLS.URL}/{@MKTPSERVICES.URL})");
      }
      
  }

  loadServices(){
    let ob = {
      "entityName":"Mktpcontractpref",
      "sql":`SELECT  TYPESERVICE, URL
            FROM MKTPSERVICES
            WHERE (CODEMKTP = ${this.integrationData.codeMktp} 
            AND STATUS=1 
            AND TYPEURL='${this.step2.get('TYPEURL').value}') `
    }
     
    this.ob2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
      next:  (data)=>{
        if ( data['SQL']){
          this.typeServiceList.next(data['SQL']);
          this.typeServiceFiltered.next(data['SQL']);
        }
      },
      error: (error)=>{
        throw error;
      }});
  
  }

  selectTabName(name){
      
      const oldName = this.selectedName;
      const old = this.stepData.findIndex(d=>d['name']==oldName)+1;
      let id = this.stepData.findIndex(d=>d['name']==name)+1;
      this.selectedName = name;
      this.selected = id;
      
      if ( old == id ){
        this.typeSelection = 'none';
      }      
      if ( old < id ){
        this.typeSelection = 'down'+this.selected;
        this.multiplyer = (old-id)*100;
        this.multiplyerBody= 100;
      }else{
        this.typeSelection = 'up'+this.selected;
        this.multiplyer = (old - id)*100;
        this.multiplyerBody= -100;
      }
  }


  convertObjectString(ob:Object,field){
      if ( ob!= null && ob[field]!=null && ob[field]!=''){
        return ob[field].join(';');
      }else{
        return null;
      }
  }


  saveDataCFI() {
    this.spinner.show('requestform');
    
    let ob = {
        entityName:'Mktpcfi',
        IDCONF:this.integrationData.idConf,
        SEQUENCE: this.integrationData.sequence,
        HEADERPROPERTIES: this.convertObjectString(this.stepHeader.getRawValue(),"HEADERPROPERTIES"),
        PARAMPROPERTIES:this.convertObjectString(this.stepParameter.getRawValue(),"PARAMPROPERTIES"),
        ...this.step1.getRawValue(),
        ...this.step2.getRawValue(),
        ...this.step3.getRawValue(),
        ...this.stepDataSave.getRawValue(),
        ...this.expressionForm.getRawValue(),
    }
    
    return new Promise((resolve,reject)=>{
        this.ob3 = this.http.post(ob,'JsonBrokerServices/save',false,true,true).subscribe(data=>{
            this.spinner.hide('requestform');  
            this.snackBar.showSuccess('Processado com Sucesso');

            resolve(true);
        },error=>{  
            this.spinner.hide('requestform');
        });
     });
  }

  
  openFormula(inp, type, formGroup:UntypedFormGroup){
    
    let params:Variable[] = [];
      
    if ( type == "URL"){
        if ( this.enableServices ){
          params.push({
            key:'@MKTPSERVICES.URL',
            value: this.getFromObservable(this.typeServiceList,"TYPESERVICE",this.step2.get('SERVICENAME').value),
            type:"T"
        });
        params.push({
          key:'@MKTPURLS.URL',
          value: this.getFromObservable(this.typeUrlList,"TYPEURL",this.step2.get('TYPEURL').value),
          type:"T"
        })
      }
    }

    this.formulaService.openFormula(inp,params).then(f=>{
      if ( type=='formulaThrottling'){
        this.formulaThrottling  =type;
      }else{
        formGroup.get(type).setValue(f);
      }
      
    });
  }
  
  ngOnDestroy(){
      //this.typeServiceList.unsubscribe();
      //this.typeUrlList.unsubscribe();
      this._onDestroy.unsubscribe();
      if ( this.ob1!= null ){ this.ob1.unsubscribe(); }
      if ( this.ob2!= null ){ this.ob2.unsubscribe(); }
      if ( this.ob3!= null ){ this.ob3.unsubscribe(); }
  }
  
  getFromObservable(typeServiceList: BehaviorSubject<Object[]>, col:string,value: any): string {
      return typeServiceList.getValue().find(d=>d[col]==value)['URL'];
  }

  changeServico(evento:MatSelectChange){
      this.doFace(evento.value);
  }

  get typeTech(){
      return this.step1.get("TYPETECH").value;
  }

  disableAll(){
    this.showSaveResponse = false;
    this.saveResponse = false;
    this.showRequestMethod = false;
    this.showQuota = false;
    this.enableServices = false;
    this.showHeader = false;
    this.showCID = false;
    this.showParams = false;
    this.showOthers = false;
    this.showPagination = false;
    this.showTypeTech = false;
    this.showConsultaDados = false;
    this.showSankhyaInstance = false;
    this.showSankhyaFile = false;
    this.showConn = false;
    this.showDataTransform = false;
    this.showSankhyaQuerys = false;
  }

  onChangeTypeTech(){
    if ( this.typeTech == 4 || this.typeTech == 5){
      
      this.showHeader = false;
      this.showParams = false;
      this.showPagination = false;
      this.showEnableServices = false;
      this.showCID = false;
      this.showQuota = false;
      this.showSankhyaQuerys = true;
      this.step2.get('REQUESTMETHOD').setValue('POST');
      if ( this.typeTech ==5 ){
        this.step2.get('SERVICENAME').setValue("DbExplorerSP.executeQuery");
      }else{
        this.step2.get('SERVICENAME').setValue("CRUDServiceProvider.loadView");
      }
      this.step2.get('LOGOUT').setValue("S");

    }else{
      this.step2.get("SERVICENAME").setValue(null);
      this.showHeader = true;
      this.showParams = true;
      this.showPagination = true;
      this.showEnableServices = true;
      this.showCID = true;
      this.showQuota = true;
      this.showSankhyaQuerys = false;
    }

    this.changeStepView('showHeader','header');
    this.changeStepView('showParams','param');
    this.changeStepView('showCID','dpara');
    this.changeStepView('showSankhyaQuerys','snkquery');
  }

  doFace(value){
    
    this.integrationData.typeIntegration.nuInt = value;
    this.disableAll();
    
    if ( value == 1 || value == 7 || value == 11 || value == 12 ){
      this.showConsultaDados = true;
      this.setRequired(this.expressionForm,'EXPRESSION');
    }

    if ( value == 1|| value == 2 ){
      this.showTypeTech = true;
      this.showHeader = true;
      this.showOthers = true;
      this.showParams = true;
      this.showQuota = true;
      this.showConn = true;
      this.showRequestMethod = true;
      this.showPagination = true;
      if ( this.step2.get('SERVICENAME').value!=null && this.step2.get('SERVICENAME').value !=''
      && this.typeTech != 4 && this.typeTech != 5){
        this.enableServices = true;
      }
      this.showCID = true;

      if ( value == 2 && this.typeTech == 4 || this.typeTech == 5){
        
        this.step2.get('REQUESTMETHOD').setValue('POST');
        if ( this.typeTech ==5 ){
            this.step2.get('SERVICENAME').setValue("DbExplorerSP.executeQuery");
          }else{
            this.step2.get('SERVICENAME').setValue("CRUDServiceProvider.loadView");
          }
          
          this.showSankhyaQuerys = true;
          this.showCID = false;
          this.showHeader = false;
          this.showParams = false;
          this.showPagination = false;
          this.showEnableServices = false;
          this.showQuota = false;
      }

      this.setRequired(this.step1,'TYPETECH');
      this.setRequired(this.step2,'REQUESTMETHOD');
    }else{
      this.setNonRequired(this.step1,'TYPETECH');
      this.setNonRequired(this.step2,'REQUESTMETHOD');
    }

    if ( value == 1 || value == 4 || value == 5 || value == 11 || value == 12){
      setTimeout(()=>{
        this.showSaveResponse = true;
        this.saveResponse = false;
        this.changeStepView('showSaveResponse','datasave');
        this.changeStepView('saveResponse','datasave');  
      });
    }


    if ( value == 5 || value == 11 || value == 12){
        if ( value == 5 ){
          this.showSankhyaInstance = true;
        }

        if ( value == 11 || value ==12 ){
          this.showSankhyaFile = true;

          this.step1.get('REQUESTMETHOD').setValue("POST");
          this.step1.get('SERVICENAME').setValue("crud.find");
          this.step1.get('LOGOUT').setValue("S");
          this.step1.get('TYPE').setValue("3");

          if ( value == 11 ){
            this.step1.get('TYPETECH').setValue("1");
          }

          if ( value == 12 ){
            this.step1.get('TYPETECH').setValue("2");
          }
        }else{
          this.step1.get('TYPETECH').setValue(null);
        }
        
    }

    if ( value == 4 || value == 7 || value == 16 ||value == 19|| value== 5 || value==11 || value==12 ){
      if ( value == 7){
        this.showCID = true;
        this.showOthers = true;
      }
      if ( value == 4 ){
        this.showCID = true;
        this.showDataTransform = true;
        this.showTypeTech = true;
      }
    }

    if ( value == 11 ){
        //this.form
    }

    this.configVariables(this.step1,'saveResponse');
    this.configVariables(this.step1,'retry');
    this.configVariables(this.expressionForm,'joinSql');
    this.configVariables(this.step1,'active');
    this.configVariables(this.step2,'formulaOffSet');
    this.configVariables(this.step2,'hasOffSet');
    this.configVariables(this.step2,'offSetBody');

    this.step1.get('TYPE').setValue(this.typeServicesCodes.find(d=>d.serviceType==value).type);
    
    this.changeStepView('showSankhyaInstance','snkinst');
    this.changeStepView('showSankhyaFile','snkfile');
    this.changeStepView('showSaveResponse','datasave');
    this.changeStepView('saveResponse','datasave');
    this.changeStepView('showConsultaDados','query');
    this.changeStepView('showHeader','header');
    this.changeStepView('showParams','param');
    this.changeStepView('showDataTransform','datatransform');
    this.changeStepView('showOthers','misc');
    this.changeStepView('showConn','conn');
    this.changeStepView('showCID','dpara');
    this.changeStepView('showSankhyaQuerys','snkquery');
  }

  configVariables(form:UntypedFormGroup,field:string){

    let value = form.get(field.toUpperCase()).value;
    if ( value != null ){
      setTimeout(()=>{
        this[field] = (value == "S" ? true : false);
      });
    }else{
      setTimeout(()=>{
        this[field] = false;
      });
    }
  }

  onToggleChange(column){

    if  ( column=="FORMULAOFFSET" || column=="OFFSETBODY"){
      if ( this.formulaOffSet && this.offSetBody ){
         if ( column=="FORMULAOFFSET"){
            setTimeout(()=>{this.formulaOffSet = false;},100);
         }else{
            setTimeout(()=>{this.offSetBody = false;},100);
            
         }
         this.snackBar.showError('Não é permitido ativar as duas opções.');
         return;
      }
    }
    


    if ( column=="SAVERESPONSE"){
      if ( this.saveResponse ){
        this.step1.get(column).setValue("S");
      }else{
        this.step1.get(column).setValue("N");
      }
      
      if ( this.saveResponse ){
        this.showTableName = true;
      }else{
        this.showTableName = false;
      }
      //this.changeStepView('showSaveResponse','datasave');
      this.changeStepView('saveResponse','datasave');
    }

    if ( column=="RETRY"){
      if ( this.retry ){
        this.step1.get(column).setValue("S");
      }else{
        this.step1.get(column).setValue("N");
      }
      
    }
    
    if ( column=="JOINSQL"){
      if ( this.joinSql ){
        this.expressionForm.get(column).setValue("S");
      }else{
        this.expressionForm.get(column).setValue("N");
      }
      
    }

    if ( column=='ACTIVE'){
      if ( this.active ){
        this.step1.get(column).setValue("S");
      }else{
        this.step1.get(column).setValue("N");
      }
      
    }

    if ( column=='HASOFFSET'){
      if ( this.hasOffSet ){
        this.step2.get(column).setValue("S");
      }else{
        setTimeout(()=>{this.formulaOffSet = false;},100);
        setTimeout(()=>{this.offSetBody = false;},100);
        this.step2.get("OFFSETEXPRESSION").setValue(null);
        this.step2.get("OFFSETSTART").setValue(null);
        this.step2.get("OFFSETINTERVAL").setValue(null);
        this.step2.get(column).setValue("N");
      }  
    }

    
    if ( column=='FORMULAOFFSET'){
      if ( this.formulaOffSet ){
        this.step2.get(column).setValue("S");
      }else{
        this.step2.get(column).setValue("N");
      }
    }

    if ( column == "OFFSETBODY"){
      if ( this.offSetBody ){
        this.step2.get(column).setValue("S");
      }else{
        this.step2.get(column).setValue("N");
      }
    }

  }

  changeStepView(field,param){
    let index = this.stepData.findIndex(d=>d['name'] == param);
      if ( this[field] == true){
        let newData = this.step.find(d=>d['name'] == param);
          if ( index == -1 ){
              this.stepData.push(newData);
          }   
      }else{
        if ( index > -1){
          this.stepData.splice(index,1);
        }
      }
  }

  setRequired(form:UntypedFormGroup, field){
     form.get(field).setValidators(Validators.required);
  }

  setNonRequired(form:UntypedFormGroup, field){
    form.get(field).removeValidators(Validators.required);
 }

 get QUOTAREQUEST(){
    return this.step2.get('QUOTAREQUEST').value == null? '' :this.step2.get('QUOTAREQUEST').value ;
 }

 onChangeThrottlingFormula(evento,field:string){
    
    let data:Object  = JSON.parse(this.step2.get('SLEEPFORMULA').value);
    if ( data == null ){
        data = {
            [field]: evento
        }
    }else{
        data[field]  = evento;
    }
    this.step2.get('SLEEPFORMULA').setValue(JSON.stringify(data));
  }


  filterOptions(evento,clearAll:boolean){
    
    if ( clearAll){
        this.typeServicesCodesFiltered.push(...this.typeServicesCodes);
    }

    if (evento){
      this.typeServicesCodesFiltered = this.typeServicesCodes.filter((value)=>{
        if ( value['name'].toLowerCase().indexOf( evento.toLowerCase())>-1) {
          return true;
        }else{
          return false;
        }
      });
    }

  }
  
  transformObjectArray(value: string, formArray:FormArray) {
  
    if ( value ){
      if ( value.split(";").length == 0){
        formArray.push(new FormControl(value));
      }else{
        value.split(";").forEach((data:string)=>{
          formArray.push(new FormControl(value));
        });
      }
      
    }
  }
  
  
}
